import { useCheckoutStore } from "@/stores/checkout";
import { useUserStore } from "@/stores/user";
import { useGenericStore } from "@/stores/generic";
import { BOSSESS } from "~/lib/enums";

const plats = {
  1: "PC",
  2: "Xbox",
  3: "PlayStation",
  4: "Nintendo Switch",
  5: "Mobile",
};
function calculateChoose(game = {}, pack = {}, checkout = {}, user = {}) {
  const checkoutStore = useCheckoutStore();
  let price = 0;
  let nonDiscountedPrice = 0;
  let basePrice = 0;
  let time = 0;
  let cashback = 0;
  let infos = {};
  let progressiveDiscount = 0;
  let nonDiscountedUsdPrice = 0;
  let nonDiscountedUsdPriceBase = 0;
  let discountUsdPrice = 0;
  let platformSlab = null;
  switch (pack.slug) {
    // APEX LEGENDS
    case "apex-rank-boosting":
      infos = calculateRocketRainbowRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "apex-wins-boosting":
      infos = calculateWinBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "apex-provisional-matches-boosting":
      infos = calculateWinsBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "apex-badges-boosting":
      infos = calculateAchievementsBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "apex-master-predator-rp-boost":
      infos = calculateChampionRankBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "apex-predator-boost":
      infos = calculateAboveAllBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    // ROCKET LEAGUE
    case "rocket-league-supersonic-rank-boost":
      infos = calculateChampionRankBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "rocket-league-rank-boost":
      infos = calculateRocketRainbowRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "rocket-league-wins-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "rocket-league-rewards-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "rocket-league-tournament-boost":
      infos = calculateTournamentBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "rocket-league-placements-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    // RAINBOW SIX SIEGE

    case "rainbow-six-siege-champion-rank-boost":
      infos = calculateChampionRankBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "rainbow-six-siege-rank-boost":
      infos = calculateRocketRainbowRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "rainbow-six-siege-wins-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    // DOTA 2
    case "dota-2-mmr-boost-service":
      infos = calculateRankBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "dota-2-win-rate-boosting":
      infos = calculateDotaWinRate(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "dota-2-calibration-boost":
      infos = calculateRankTierGameBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "dota-2-low-priority-removal":
      infos = calculateRankTierGameBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    // OVERWATCH
    case "ow-rank-boost":
      infos = calculateRocketRainbowRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "ow-competitive-drive-boost":
      infos = calculateOWDriveBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "ow-galactic-guns-boost":
      infos = calculateGalacticWinBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "ow-win-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "ow-placements-boost":
      infos = calculateRankTierGameBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "ow-stadium-boost":
      infos = calculateOw2StadiumBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    // COUNTER STRIKE 2:
    case "counter-strike-2-rank-boost":
      infos = calculateRankBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "counter-strike-2-ranked-win-boost":
      infos = calculateCounterStrikeWinBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "counter-strike-2-faceit-division-boosting":
      infos = faceitDivisionBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "counter-strike-2-faceit-rank-boosting":
      infos = calculateFaceRankBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "counter-strike-2-faceit-win-boosting":
      infos = calculateCounterStrikeWinBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "counter-strike-2-faceit-placements-boosting":
      infos = calculateFaceitPlacementBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    // LEAGUE OF LEGENDS

    case "league-of-legends-rank-boost":
      infos = calculateLolValRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "league-of-legends-ranked-win-boost":
      infos = calculateRankTierGameBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "league-of-legends-placements-boost":
      infos = calculateRankTierGameBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "league-of-legends-clash-boost":
      infos = calculateLeagueOfLegendClash(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "league-of-legends-arena-boost":
      infos = calculateLeagueOfLegendSoulFighter(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "league-of-legends-mastery-boost":
      infos = calculateLeagueOfLegendChampMastery(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    // VALORANT
    case "valorant-rank-boost":
      infos = calculateLolValRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "valorant-net-wins-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "valorant-placements-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    // FORTNITE
    case "fortnite-rank-boost":
      infos = calculateRocketRainbowRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "fortnite-reload-rank-boost":
      infos = calculateRocketRainbowRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "fortnite-rocket-racing-boost":
      infos = calculateRocketRainbowRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "fortnite-competitive-wins-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    // TEAMFIGHT
    case "teamfight-tactics-divisions-boost":
      infos = calculateLolValRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "teamfight-tactics-double-up-boost":
      infos = calculateLolValRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "teamfight-tactics-placements-boost":
      infos = calculateRankTierGameBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "teamfight-tactics-ranked-wins-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "teamfight-tactics-hyper-roll-boost":
      infos = calculateHypeRoll(pack, checkout);
      basePrice = infos.price;
      time = infos.time;
      break;
    case "the-finals-rank-boost":
      infos = calculateTheFinalsRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "the-finals-win-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "the-finals-ranked-unlock-boost":
      infos = calculateTheFinalsRankedUnlock(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "the-finals-battle-pass-boost":
      infos = calculateTheFinalsBattlePass(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "the-finals-gadgets-weapons-boost":
      infos = calculateGadgesAndWeapons(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    // UNRATED WINS
    case "league-of-legends-unrated-matches-boost":
    case "valorant-unrated-matches-boost":
    case "rainbow-six-siege-unrated-matches-boost":
    case "rocket-league-unrated-matches-boost":
    case "ow-unrated-matches-boost":
    case "dota-2-unrated-matches-boosting":
    case "apex-unrated-matches-boosting":
    case "fortnite-unrated-matches-boost":
    case "teamfight-tactics-unrated-matches-boost":
    case "the-finals-unrated-matches-boost":
    case "marvel-rivals-unrated-matches-boost":
    case "rematch-unrated-matches-boost":
      infos = calculateUnratedWins(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    // ELEARNING
    case "ow-e-learning":
    case "apex-legends-e-learning":
    case "dota-2-e-learning":
    case "counter-strike-2-e-learning":
    case "rocket-league-e-learning":
    case "rainbow-six-siege-e-learning":
    case "valorant-e-learning":
    case "league-of-legends-e-learning":
    case "fortnite-e-learning":
    case "teamfight-tactics-e-learning":
    case "the-finals-e-learning":
      infos = calculateElearning(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    // MMOS WOW
    case "wow-honor-boost":
      infos = calculateHonorFarm(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "wow-conquest-boost":
      infos = calculateConquestFarm(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "wow-leveling-boost":
    case "path-of-exile-2-power-leveling-boost":
      infos = calculateLevelBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "wow-2v2-arena-boost":
      infos = calculateRatingBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "wow-battlegrounds-boost":
    case "wow-battleground-blitz-boost":
      infos = calculateRatingBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "wow-3v3-arena-boost":
      infos = calculateRatingBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "wow-solo-shuffle-boost":
      infos = calculateRatingBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "wow-raid-boost":
      infos = calculateWowRaidBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "buy-wow-gold":
      infos = calculateWoWGoldBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "wow-mythic-dungeon-boost":
      infos = calculateWoWMythicPlus(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "black-ops-6-camo-boost":
    case "black-ops-6-zombie-camo-boost":
    case "warzone-camo-boost":
      infos = calculateCamoBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "black-ops-6-prestige-boost":
      infos = calculatePrestigeBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "black-ops-6-weapon-leveling-boost":
      infos = calculateWeaponLevelBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "black-ops-6-nuke-boost":
      infos = calculateNukeBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "black-ops-6-reticles-boost":
    case "black-ops-6-zombie-reticles-boost":
      infos = calculateNukeBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "marvel-rivals-hero-proficiency-boost":
      infos = calculateMarvelHeroProficiency(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "rematch-rank-boost":
      infos = calculateMarvelRivalsRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "rematch-wins-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "rematch-placements-boost":
      infos = calculateRankTierGameBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "marvel-rivals-rank-boost":
      infos = calculateMarvelRivalsRankBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "marvel-rivals-one-above-all-boost":
      infos = calculateAboveAllBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "marvel-rivals-win-boost":
      infos = calculateRankTierWinsBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "marvel-rivals-achievements-boost":
      infos = calculateAchievementsBoosting(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "path-of-exile-2-currency-boost":
      infos = calculatePoeCurrencyBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "path-of-exile-2-leveling-gear-boost":
      infos = calculatePoeGearBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "path-of-exile-2-ascension-trials-boost":
      infos = calculateAscensionTrials(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "path-of-exile-2-campaign-boost":
      infos = calculateCampaignBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "fc-coins-boost":
      infos = calculateFc25Coins(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "fc-coaching-boost":
    case "rematch-coaching-boost":
      infos = calculateFc25Coaching(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "fc-squad-battles-boost":
      infos = calculateFc25BattleBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "fc-objectives-boost":
      infos = calculateFc25ObjectiveBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "fc-fut-champions-final-boost":
      infos = calculateFc25ChampionsFinal(pack, checkout);
      if (infos.platformSlab) {
        platformSlab = infos.platformSlab;
      }
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "fc-fut-champions-playoffs-boost":
      infos = calculateFc25PlayoffBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "fc-division-rivals-boost":
      infos = calculateFc25DivisionRivals(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "fc-division-rivals-wins-boost":
      infos = calculateFc25DivisionRivalsWins(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "fc-tots-cup-boost":
      infos = calculateUnratedWinsFc(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "clash-royale-path-of-legends-boost":
      infos = calculateRoyalePathOfLegends(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "clash-royale-arena-boost":
      infos = calculateRoyaleArenaTrophies(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "clash-royale-trophies-boost":
      infos = calculateRoyaleArenaTrophies(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "clash-royale-crl-20-wins-boost":
      infos = calculateClrBoost(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;

    case "clash-royale-challenges-boost":
      infos = calculateRoyaleChallenges(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    case "clash-2v2-league-boost":
      infos = calculateRoyaleLeague(pack, checkout);
      basePrice = infos.price;
      time = infos.timing;
      break;
    default:
  }
  price = handlePriceIncrementToBase(pack, checkout, basePrice);

  if (basePrice > 0 && checkout.difficulty) {
    let pp = calculateDifficulty(pack, checkout, basePrice, game);
    price += pp;
  }
  // CALCULATING PACK OPTIONS
  if (basePrice > 0 && checkout.packOptions.length > 0) {
    // console.log("basePrice", basePrice);
    let optionedPrice = calculatePackOption(
      pack,
      checkout,
      basePrice,
      game,
      "cart"
    );
    // console.log("optionedPrice", optionedPrice);
    price += optionedPrice;
  }
  // CALCULATING ROLES PRICE
  if (basePrice > 0 && checkout.roles.length > 0) {
    let optionedPrice = calculateRoles(pack, checkout, basePrice);
    price += optionedPrice;
  }

  // CALCULATING EXTRA OPTION
  if (basePrice > 0 && Object.keys(checkout.packExtraOptions).length > 0) {
    // console.log("basePrice", basePrice);

    let optionedPrice = calculatePackExtraOptions(pack, checkout, basePrice);
    // console.log("extraOptionedPrice", optionedPrice);

    price += optionedPrice;
  }

  // CALCULATING QUEUE PRICE
  if (basePrice > 0 && checkout.queue !== null) {
    let optionedPrice = calculateQueue(pack, checkout, basePrice);
    price += optionedPrice;
  }

  // CALCULATING SERVER PRICE
  if (
    checkoutStore.fullGame.servers &&
    checkoutStore.fullGame.servers.length > 0 &&
    checkout.server &&
    game?.slug !== "world-of-warcraft-boost"
  ) {
    let selectedServer = checkoutStore.fullGame.servers.find(
      (server) => server.id == checkout.server?.value
    );
    if (
      selectedServer?.type === "variable" &&
      selectedServer?.price_type === 0
    ) {
      price += (basePrice * selectedServer.price) / 100;
    }
  }

  if (
    game?.slug === "world-of-warcraft-boost" &&
    pack?.servers?.length > 0 &&
    pack?.slug !== "buy-wow-gold"
  ) {
    let selectedServer = pack.servers.find(
      (server) => server.id == checkout.server?.value
    );
    if (
      selectedServer?.type === "variable" &&
      selectedServer?.price_type === 0
    ) {
      price += (basePrice * selectedServer.price) / 100;
    }
  }
  // CALCULATE ROLE
  if (
    checkoutStore.getCartGame.roles &&
    checkoutStore.getCartGame.roles.length > 0 &&
    checkout.role
  ) {
    let selectedRole = checkoutStore.getCartGame.roles.find(
      (role) => role.id == checkout.role
    );
    if (selectedRole?.type === "variable" && selectedRole?.price_type === 0) {
      price += (basePrice * selectedRole.price) / 100;
    }
  }

  // CALCULATE PLATFORM
  if (
    checkoutStore.getSelectedPlatform &&
    checkoutStore.fullGame?.platforms?.length > 0 &&
    !platformSlab
  ) {
    const selectedPlatform = checkoutStore.fullGame.platforms.find(
      (plat) => plat.id === checkoutStore.getSelectedPlatform
    );

    if (
      selectedPlatform?.type === "variable" &&
      selectedPlatform?.price_type === 0 &&
      pack.slug !== "marvel-rivals-one-above-all-boost"
    ) {
      price += (basePrice * selectedPlatform.price) / 100;
    }
    if (
      pack.slug === "marvel-rivals-one-above-all-boost" &&
      selectedPlatform?.title !== "PC"
    ) {
      price -= (basePrice * 24) / 100;
    }

    // if (
    //   [
    //     "fc-fut-champions-playoffs-boost",
    //     "fc-division-rivals-boost",
    //     "fc-division-rivals-wins-boost",
    //     "fc-squad-battles-boost",
    //     "fc-objectives-boost",
    //   ].includes(pack.slug) &&
    //   selectedPlatform?.title !== "PC"
    // ) {
    //   price += (basePrice * 20) / 100;
    // }
  }

  if (platformSlab && checkoutStore.getSelectedPlatform) {
    const selectedPlatform =
      checkoutStore.fullGame.platforms.find(
        (plat) => plat.id === checkoutStore.getSelectedPlatform
      )?.title || "";
    let platformPrice = platformSlab[selectedPlatform] || null;
    if (platformPrice) {
      if (platformPrice?.type === "fixed") price += platformPrice?.price;
      if (platformPrice?.type === "variable")
        price += (basePrice * platformPrice?.price) / 100;
    }
  }
  // nonDiscountedUsdPrice = price;
  nonDiscountedPrice = calculateCurrency(price);

  // ADDING DISCOUNTS
  nonDiscountedUsdPriceBase = price;

  const calculatedProgressiveDiscount = calcuateProgressiveDiscount(
    price,
    pack
  );

  const couponedAmount = getDiscountCoupon(price, checkout.coupon);
  nonDiscountedUsdPrice = price;
  price = price - calculatedProgressiveDiscount;
  price = price - couponedAmount;
  discountUsdPrice = price;

  basePrice = calculateCurrency(basePrice);

  if (basePrice > 0 && checkout.packOptions.length > 0) {
    price += calculatePackOption(
      pack,
      checkout,
      basePrice,
      game,
      "non_couponed"
    );
  }
  price = calculateCurrency(price);

  if (user?.id) {
    cashback = calculateCashback(user, price);
    console.log("object", cashback);
  }
  return {
    basePrice,
    nonDiscountedPrice,
    price,
    time,
    cashback,
    progressiveDiscount,
    nonDiscountedUsdPrice,
    nonDiscountedUsdPriceBase,
    discountUsdPrice,
  };
}

function calculateApexRankBoosting(pack, checkout) {
  let price = 0;
  let timing = 0;

  return {
    price,
    timing,
  };
}

function calculateRankBoosting(pack, checkout) {
  let from = checkout?.details?.rankFrom || 0;
  let to = checkout?.details?.rankTo || 8000;
  return calculateSlabPrice(pack.prices, from, to);
}
function calculateFaceRankBoosting(pack, checkout) {
  let from = checkout?.details?.rankFrom || 0;
  let to = checkout?.details?.rankTo || 8000;
  return calculateFaceitSlabPrice(pack.prices, from, to);
}

function calculateFaceitSlabPrice(prices, from = 0, to = 0) {
  let price = 0;
  let timing = 0;
  let totalDifference = to - from;
  if (totalDifference <= 0) {
    return {
      price,
      timing,
    };
  }
  let slabLowerBound = 0;
  let slabUpperBound = 0;
  let slabRate = 0;
  let slabTiming = 0;
  let difference = 0;
  let priceSlab = 0;
  let priceTiming = 0;

  for (let i = 0; i < prices.length; i++) {
    if (i == 0) {
      slabLowerBound = 0;
      slabUpperBound = prices[0]["slab"];
      slabRate = prices[0]["price"];
      slabTiming = prices[0]["timing"] ?? 0;
    } else {
      slabLowerBound = prices[i - 1]["slab"];
      slabUpperBound = prices[i]["slab"];
      slabRate = prices[i]["price"];
      slabTiming = prices[i]["timing"] || 0;
    }
    if (from > slabLowerBound && from <= slabUpperBound) {
      if (to <= slabUpperBound) {
        difference = to - from;
      } else {
        difference = slabUpperBound - from;
      }
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (from <= slabLowerBound && to >= slabUpperBound) {
      difference = slabUpperBound - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (to > slabLowerBound && to <= slabUpperBound) {
      difference = to - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    }
  }
  return {
    price,
    timing,
  };
}

function calculatePredatorSlabPrice(prices, from = 0, to = 0) {
  let price = 0;
  let timing = 0;
  let totalDifference = to - from;
  if (totalDifference <= 0) {
    return {
      price,
      timing,
    };
  }
  let slabLowerBound = 16000;
  let slabUpperBound = 0;
  let slabRate = 0;
  let slabTiming = 0;
  let difference = 0;
  let priceSlab = 0;
  let priceTiming = 0;
  for (let i = 0; i < prices.length; i++) {
    if (i == 0) {
      slabLowerBound = 16000;
      slabUpperBound = prices[0]["slab"];
      slabRate = prices[0]["price"];
      slabTiming = prices[0]["timing"] ?? 0;
    } else {
      slabLowerBound = prices[i - 1]["slab"];
      slabUpperBound = prices[i]["slab"];
      slabRate = prices[i]["price"];
      slabTiming = prices[i]["timing"] || 0;
    }
    if (from > slabLowerBound && from <= slabUpperBound) {
      if (to <= slabUpperBound) {
        difference = to - from;
      } else {
        difference = slabUpperBound - from;
      }

      priceSlab = difference * slabRate;
      price += priceSlab;

      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (from <= slabLowerBound && to >= slabUpperBound) {
      difference = slabUpperBound - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (to > slabLowerBound && to <= slabUpperBound) {
      difference = to - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    }
  }
  return {
    price,
    timing,
  };
}

function calculateSlabPrice(prices, from = 0, to = 0) {
  let price = 0;
  let timing = 0;
  let totalDifference = to - from;
  if (totalDifference <= 0) {
    return {
      price,
      timing,
    };
  }
  let slabLowerBound = 0;
  let slabUpperBound = 0;
  let slabRate = 0;
  let slabTiming = 0;
  let difference = 0;
  let priceSlab = 0;
  let priceTiming = 0;
  for (let i = 0; i < prices.length; i++) {
    if (i == 0) {
      slabLowerBound = 0;
      slabUpperBound = prices[0]["slab"];
      slabRate = prices[0]["price"];
      slabTiming = prices[0]["timing"] ?? 0;
    } else {
      slabLowerBound = prices[i - 1]["slab"];
      slabUpperBound = prices[i]["slab"];
      slabRate = prices[i]["price"];
      slabTiming = prices[i]["timing"] || 0;
    }
    if (from > slabLowerBound && from <= slabUpperBound) {
      if (to <= slabUpperBound) {
        difference = to - from;
      } else {
        difference = slabUpperBound - from;
      }

      priceSlab = difference * slabRate;
      price += priceSlab;

      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (from <= slabLowerBound && to >= slabUpperBound) {
      difference = slabUpperBound - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (to > slabLowerBound && to <= slabUpperBound) {
      difference = to - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    }
  }
  return {
    price,
    timing,
  };
}

// WIN BOOST
function calculateWinsBoosting(pack, checkout) {
  let numberOfGames = checkout.details?.numberOfGames || 0;
  let rankTitle = checkout.details.currentRankTitle;
  return calculcateSingleSlabIntoCount(pack.prices, numberOfGames, rankTitle);
}
function calculateWinBoosting(pack, checkout) {
  let numberOfGames = checkout.details?.numberOfWins || 0;
  let rankTitle = checkout.details.currentRankTitle;
  return calculcateSingleSlabIntoCount(pack.prices, numberOfGames, rankTitle);
}

function calculateCounterStrikeWinBoost(pack, checkout) {
  let price = 0;
  let timing = 0;
  // console.log(checkout.details.rankFrom);
  const gamePackPrices = pack.prices.filter(
    (price) => price.slab <= checkout.details.rankFrom
  );
  let gamePackPrice = gamePackPrices[gamePackPrices.length - 1];
  if (gamePackPrice) {
    price = gamePackPrice.price * checkout.details.numberOfWins;
    timing = gamePackPrice.timing * checkout.details.numberOfWins;
  }

  return {
    price,
    timing,
  };
}

function calculateFaceitPlacementBoosting(pack, checkout) {
  let price = 0;
  let timing = 0;

  const gamePackPrice = pack.prices.find(
    (price) => price.slab === checkout.details.numberOfGames
  );
  if (gamePackPrice) {
    price = gamePackPrice.price;
    timing = gamePackPrice.timing;
  }

  return {
    price,
    timing,
  };
}

function calculcateSingleSlabIntoCount(
  boostingPackSlabs,
  totalCount,
  rankTitle
) {
  let price = 0;
  let timing = 0;

  if (totalCount > 0) {
    const slab = boostingPackSlabs.find(
      (packSlab) => packSlab.title === rankTitle
    );
    price = totalCount * slab.price;
    timing = totalCount * slab.timing;
  }

  return {
    price,
    timing,
  };
}

// ROCKET LEAGUE AND R6S RANK BOOSTING
function calculateRocketRainbowRankBoost(pack, checkout) {
  const {
    currentRankTitle,
    currentDivisionTitle,
    desiredRankTitle,
    desiredDivisionTitle,
  } = checkout.details;
  if (!currentRankTitle || !desiredRankTitle) {
    return {
      price: 0,
      timing: 0,
    };
  }

  let currentRank = `${currentRankTitle} ${currentDivisionTitle}`;
  let desiredRank = `${desiredRankTitle} ${desiredDivisionTitle}`;
  if (!currentDivisionTitle) {
    currentRank = currentRankTitle;
  }
  if (!desiredDivisionTitle) {
    desiredRank = desiredRankTitle;
  }
  const slabs = pack.prices;
  let price = 0;
  let timing = 0;
  let fromFound = false;
  // console.log(currentRank, desiredRank);
  if (currentRank && desiredRank) {
    for (let i = 0; i < slabs.length; i++) {
      const from = slabs[i].title.split(" > ")[0];
      const to = slabs[i].title.split(" > ")[1];
      if (from === currentRank) {
        price += slabs[i].price;
        timing += slabs[i].timing;
        fromFound = true;
        if (to === desiredRank) {
          break;
        }
      } else if (fromFound) {
        price += slabs[i].price;
        timing += slabs[i].timing;
      }
      if (to === desiredRank || from === desiredRank) {
        break;
      }
    }
  }
  return {
    price: price,
    timing: timing,
  };
}

function calculateRankTierWinsBoost(pack, checkout) {
  let { currentRankTitle, currentDivisionTitle, numberOfWins } =
    checkout.details;

  const count = numberOfWins || 1;
  let divisionNumber = 0;
  if (
    pack.slug !== "rainbow-six-siege-wins-boost" &&
    pack.slug !== "league-of-legends-ranked-win-boost" &&
    pack.slug !== "league-of-legends-placements-boost" &&
    pack.slug !== "valorant-placements-boost" &&
    pack.slug !== "valorant-net-wins-boost" &&
    pack.slug !== "ow-win-boost" &&
    pack.slug !== "ow-placements-boost" &&
    pack.slug !== "dota-2-win-rate-boosting" &&
    pack.slug !== "dota-2-low-priority-removal" &&
    pack.slug !== "dota-2-calibration-boost" &&
    pack.slug !== "fortnite-competitive-wins-boost" &&
    pack.slug !== "the-finals-win-boost" &&
    pack.slug !== "teamfight-tactics-ranked-wins-boost" &&
    pack.slug !== "marvel-rivals-win-boost" &&
    pack.slug !== "rematch-wins-boost"
  ) {
    if (currentDivisionTitle === "III") {
      divisionNumber = 3;
    } else if (currentDivisionTitle === "II") {
      divisionNumber = 2;
    } else if (currentDivisionTitle === "I") {
      divisionNumber = 1;
    }
  } else {
    divisionNumber = currentDivisionTitle;
  }

  let slabTitle = currentRankTitle + " " + currentDivisionTitle;
  let isCustomRank = false;
  if (divisionNumber === "") {
    slabTitle = currentRankTitle;
  }
  if (
    (currentRankTitle === "Master" ||
      currentRankTitle === "Immortal" ||
      currentRankTitle === "Eternity") &&
    checkout.game !== 6
  ) {
    isCustomRank = true;
  }
  if (
    currentRankTitle === "Diamond" &&
    currentDivisionTitle === "1" &&
    checkout.game === 16
  ) {
    isCustomRank = true;
  }
  let price = 0;
  let timing = 0;

  if (
    pack.prices &&
    currentRankTitle &&
    divisionNumber !== 0 &&
    isCustomRank === false
  ) {
    const slab = pack.prices.find((packSlab) => packSlab.title === slabTitle);
    console.log(slab);
    if (slab?.price && slab?.timing) {
      price = slab?.price * count;
      timing = slab?.timing * count;
    }
  } else if (
    pack.prices &&
    currentRankTitle &&
    isCustomRank === false &&
    currentRankTitle === "Unranked"
  ) {
    const slab = pack.prices.find(
      (packSlab) => packSlab.title === currentRankTitle
    );
    if (slab?.price && slab?.timing) {
      price = slab?.price * count;
      timing = slab?.timing * count;
    }
  } else if (isCustomRank === true) {
    let slabs = [];
    if (checkout.game === 1) {
      slabs = pack.prices.filter((slab) => slab.slab >= 30);
    }
    if (checkout.game === 2) {
      slabs = pack.prices.filter((slab) => slab.slab >= 22);
    }
    if (checkout.game === 9 && checkout.pack === 53) {
      slabs = pack.prices.filter((slab) => slab.slab > 10);
    }
    if (checkout.game === 9 && checkout.pack === 52) {
      slabs = pack.prices.filter((slab) => slab.slab > 28);
    }
    if (checkout.game === 16 && checkout.pack === 56) {
      slabs = pack.prices.filter((slab) => slab.slab > 19);
    }
    if (checkout.game === 19 && checkout.pack === 92) {
      slabs = pack.prices.filter((slab) => slab.slab > 22);
    }
    let lp = checkout.details.currentRankLp;
    if (checkout.game === 19 && checkout.pack === 92) {
      lp = checkout.details.currentRankPoints;
    }

    const s = slabs.filter((slab) => slab.slab >= lp);
    if (s[0]) {
      price = s[0]?.price * count;
      timing = s[0]?.timing * count;
    }
  }
  console.log("price", price);
  return {
    price,
    timing,
  };
}
function calculateRankTierGameBoost(pack, checkout) {
  let { currentRankTitle, currentDivisionTitle, numberOfGames } =
    checkout.details;

  const count = numberOfGames || 1;

  let divisionNumber = 0;
  if (
    pack.slug !== "rainbow-six-siege-wins-boost" &&
    pack.slug !== "league-of-legends-ranked-win-boost" &&
    pack.slug !== "league-of-legends-placements-boost" &&
    pack.slug !== "valorant-placements-boost" &&
    pack.slug !== "valorant-net-wins-boost" &&
    pack.slug !== "ow-win-boost" &&
    pack.slug !== "ow-placements-boost" &&
    pack.slug !== "dota-2-win-rate-boosting" &&
    pack.slug !== "dota-2-low-priority-removal" &&
    pack.slab !== "dota-2-calibration-boost" &&
    pack.slab !== "teamfight-tactics-placements-boost" &&
    pack.slab !== "teamfight-tactics-ranked-wins-boost" &&
    pack.slab !== "rematch-placements-boost"
  ) {
    if (currentDivisionTitle === "III") {
      divisionNumber = 3;
    } else if (currentDivisionTitle === "II") {
      divisionNumber = 2;
    } else if (currentDivisionTitle === "I") {
      divisionNumber = 1;
    }
  } else {
    divisionNumber = currentDivisionTitle;
  }

  let slabTitle = currentRankTitle + " " + currentDivisionTitle;
  let isCustomRank = false;

  if (divisionNumber === "") {
    slabTitle = currentRankTitle;
  }
  if (!currentDivisionTitle && pack.id === 53) {
    slabTitle = currentRankTitle;
  }

  if (
    (currentRankTitle === "Master" || currentRankTitle === "Immortal") &&
    ![6].includes(checkout.game)
  ) {
    isCustomRank = true;
  }
  let price = 0;
  let timing = 0;

  // console.log(currentRankTitle, isCustomRank, checkout.game);

  if (pack.prices && currentRankTitle && isCustomRank === false) {
    const slab = pack.prices.find((packSlab) => packSlab.title === slabTitle);
    if (slab?.price && slab?.timing) {
      price = slab?.price * count;
      timing = slab?.timing * count;
    }
  } else if (isCustomRank === true) {
    let slabs = [];
    if (checkout.game === 1 && checkout) {
      slabs = pack.prices.filter((slab) => slab.slab >= 29);
    }
    if (checkout.game === 2) {
      slabs = pack.prices.filter((slab) => slab.slab >= 22);
    }
    if (checkout.game === 9 && checkout.pack === 53) {
      slabs = pack.prices.filter((slab) => slab.slab > 10);
    }
    if (checkout.game === 9 && checkout.pack === 52) {
      slabs = pack.prices.filter((slab) => slab.slab > 28);
    }
    if (checkout.game === 5 && checkout.pack === 19) {
      slabs = pack.prices.filter((slab) => slab.slab > 35);
    }
    let lp = checkout.details.currentRankLp;
    const s = slabs.filter((slab) => slab.slab >= lp);

    if (s[0]) {
      price = s[0]?.price * count;
      timing = s[0]?.timing * count;
    }
  }
  return {
    price,
    timing,
  };
}

function calculateTournamentBoost(pack, checkout) {
  let rankTitle = checkout?.details.currentRankTitle || "Bronze";
  let price = 0;
  let timing = 0;

  if (pack?.prices && rankTitle) {
    const slab = pack.prices.find((packSlab) => packSlab.title === rankTitle);
    price = slab?.price || 0;
    timing = slab?.timing || 0;
  }

  return {
    price,
    timing,
  };
}
function calculateDotaWinRate(pack, checkout) {
  let rankTitle = checkout?.details.currentRankTitle || "Bronze";
  let price = 0;
  let timing = 0;
  const numberOfWins = checkout?.details?.numberOfWins;
  if (pack?.prices && rankTitle) {
    const slab = pack.prices.find((packSlab) => packSlab.title === rankTitle);
    price = slab?.price * numberOfWins || 0;
    timing = slab?.timing * numberOfWins || 0;
  }

  return {
    price,
    timing,
  };
}

function calculateLolValRankBoost(pack, checkout) {
  let price = 0;
  let timing = 0;
  if (
    !checkout?.details.currentRankTitle ||
    !checkout?.details.desiredRankTitle
  ) {
    return {
      price: 0,
      timing: 0,
    };
  }
  const currentRank = `${checkout?.details?.currentRankTitle} ${checkout?.details?.currentDivisionTitle}`;
  let desiredRank = "";
  if (checkout?.details?.currentDivisionTitle) {
    desiredRank = `${checkout?.details?.desiredRankTitle} ${checkout?.details?.desiredDivisionTitle}`;
  } else {
    desiredRank = `${checkout?.details?.desiredRankTitle}`;
  }

  const slabs = pack.prices;
  let fromFound = false;
  let lpFound = false;
  let startingSlab = null;
  let contribution = 0;
  let difference = 0;
  if (currentRank && desiredRank) {
    const desiredLp = checkout.details.desiredRankLp;
    const currentLp = checkout.details.currentRankLp;
    let numberOfPoints = desiredLp - currentLp;
    let onlyLpPoints = parseInt(desiredLp);
    let lpPrice = 0;

    for (let i = 0; i < slabs.length; i++) {
      if (slabs[i].title) {
        const from = slabs[i].title.split(" > ")[0];
        const to = slabs[i].title.split(" > ")[1];
        if (from === currentRank) {
          price += slabs[i].price;
          timing += slabs[i].timing;
          fromFound = true;
          if (
            to === desiredRank &&
            !["Immortal", "Master"].includes(desiredRank)
          ) {
            break;
          }
        } else if (fromFound) {
          price += slabs[i].price;
          timing += slabs[i].timing;
        }
        if (
          (to === desiredRank || from === desiredRank) &&
          !["Immortal", "Master"].includes(desiredRank)
        ) {
          break;
        }
      } else {
        if (desiredLp === 0) {
          break;
        }
        if (
          !["Master", "Immortal"].includes(checkout.details.currentRankTitle)
        ) {
          if (slabs[i].slab !== 0) {
            if (onlyLpPoints < 100) {
              lpPrice += onlyLpPoints * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            } else {
              lpPrice += 100 * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            }
            if (onlyLpPoints > 100) {
              onlyLpPoints = onlyLpPoints - 100;
            }
          }
          if (desiredLp <= slabs[i].slab) {
            price += lpPrice;
            break;
          }
        } else {
          if (currentLp <= slabs[i].slab && !lpFound) {
            startingSlab = { ...slabs[i] };
            if (currentLp <= slabs[i].slab && desiredLp <= slabs[i].slab) {
              contribution = numberOfPoints;
            } else {
              contribution += slabs[i].slab - currentLp;
              numberOfPoints = numberOfPoints - contribution;
            }
            lpFound = true;
          }
          if (lpFound) {
            if (slabs[i].slab !== startingSlab.slab) {
              if (desiredLp >= slabs[i].slab) {
                difference = 100;
                numberOfPoints = numberOfPoints - 100;
                contribution += 100;
                price += difference * slabs[i].price;
                timing += difference * slabs[i].timing;
              } else {
                difference = numberOfPoints;
                numberOfPoints = numberOfPoints - difference;
                price += difference * slabs[i].price;
                timing += difference * slabs[i].timing;
                contribution += difference;
              }
            } else {
              price += contribution * slabs[i].price;
              timing += contribution * slabs[i].timing;
            }

            if (desiredLp <= slabs[i].slab) {
              break;
            }
          }
        }
      }
    }
  }
  return {
    price,
    timing,
  };
}
function calculateDota2MmrBoost(pack, checkout) {
  let price = 0;
  let timing = 0;

  if (
    !checkout?.details.currentRankTitle ||
    !checkout?.details.desiredRankTitle
  ) {
    return {
      price: 0,
      timing: 0,
    };
  }
  const currentRank = `${checkout?.details?.currentRankTitle} ${checkout?.details?.currentDivisionTitle}`;
  let desiredRank = "";
  if (checkout?.details?.currentDivisionTitle) {
    desiredRank = `${checkout?.details?.desiredRankTitle} ${checkout?.details?.desiredDivisionTitle}`;
  } else {
    desiredRank = `${checkout?.details?.desiredRankTitle}`;
  }

  const slabs = pack.prices;
  let fromFound = false;
  let lpFound = false;
  if (currentRank && desiredRank) {
    const desiredLp = checkout.details.desiredRankLp;
    const currentLp = checkout.details.currentRankLp;
    let numberOfPoints = desiredLp - currentLp;
    let onlyLpPoints = parseInt(desiredLp);
    let lpPrice = 0;

    for (let i = 0; i < slabs.length; i++) {
      if (slabs[i].title) {
        const from = slabs[i].title.split(" > ")[0];
        const to = slabs[i].title.split(" > ")[1];

        if (from === currentRank) {
          price += slabs[i].price;
          timing += slabs[i].timing;
          fromFound = true;
          if (
            to === desiredRank &&
            !["Immortal", "Master"].includes(desiredRank)
          ) {
            break;
          }
        } else if (fromFound) {
          price += slabs[i].price;
          timing += slabs[i].timing;
        }
        if (
          (to === desiredRank || from === desiredRank) &&
          !["Immortal", "Master"].includes(desiredRank)
        ) {
          break;
        }
      } else {
        if (desiredLp === 0) {
          break;
        }
        if (
          !["Master", "Immortal"].includes(checkout.details.currentRankTitle)
        ) {
          if (slabs[i].slab !== 0) {
            if (onlyLpPoints < 500) {
              lpPrice += onlyLpPoints * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            } else {
              lpPrice += 500 * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            }
            if (onlyLpPoints > 500) {
              onlyLpPoints = onlyLpPoints - 500;
            }
          }
          if (desiredLp <= slabs[i].slab) {
            price += lpPrice;
            break;
          }
        } else {
          if (currentLp <= slabs[i].slab && !lpFound) {
            lpFound = true;
          }
          if (lpFound) {
            if (numberOfPoints < 500) {
              price += numberOfPoints * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            } else if (numberOfPoints <= 1000) {
              price += 500 * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            }
            if (numberOfPoints > 500) {
              numberOfPoints = numberOfPoints - 500;
            }
            if (desiredLp <= slabs[i].slab) {
              break;
            }
          }
        }
      }
    }
  }
  return {
    price,
    timing,
  };
}

// THE FINALS
function calculateTheFinalsRankBoost(pack, checkout) {
  let price = 0;
  let timing = 0;
  if (
    !checkout?.details.currentRankTitle ||
    !checkout?.details.desiredRankTitle
  ) {
    return {
      price: 0,
      timing: 0,
    };
  }

  const currentRank = `${checkout?.details?.currentRankTitle} ${checkout?.details?.currentDivisionTitle}`;
  let desiredRank = "";
  if (checkout?.details?.currentDivisionTitle) {
    desiredRank = `${checkout?.details?.desiredRankTitle} ${checkout?.details?.desiredDivisionTitle}`;
  } else {
    desiredRank = `${checkout?.details?.desiredRankTitle}`;
  }

  const slabs = pack.prices;
  let fromFound = false;
  let lpFound = false;

  let startingSlab = null;
  let contribution = 0;
  let difference = 0;
  if (currentRank && desiredRank) {
    const desiredLp = checkout.details.desiredRankLp || 5020;
    const currentLp = checkout.details.currentRankLp || 5000;
    let numberOfPoints = desiredLp - currentLp;
    let onlyLpPoints = parseInt(desiredLp) - 5000;
    let lpPrice = 0;
    for (let i = 0; i < slabs.length; i++) {
      if (slabs[i].title) {
        const from = slabs[i].title.split(" > ")[0];
        const to = slabs[i].title.split(" > ")[1];

        if (from === currentRank) {
          price += slabs[i].price;
          timing += slabs[i].timing;
          fromFound = true;
          if (to === desiredRank && desiredRank !== "Diamond 1") {
            break;
          }
        } else if (fromFound) {
          price += slabs[i].price;
          timing += slabs[i].timing;
        }

        if (
          (to === desiredRank || from === desiredRank) &&
          desiredRank !== "Diamond 1"
        ) {
          break;
        }
      } else {
        if (desiredLp === 0) {
          break;
        }
        if (currentRank !== "Diamond 1") {
          if (slabs[i].slab !== 0) {
            if (onlyLpPoints < 100) {
              lpPrice += onlyLpPoints * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            } else {
              lpPrice += 100 * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            }
            if (onlyLpPoints > 100) {
              onlyLpPoints = onlyLpPoints - 100;
            }
          }
          if (desiredLp <= slabs[i].slab) {
            price += lpPrice;
            break;
          }
        } else if (slabs[i].slab !== 5000) {
          if (currentLp <= slabs[i].slab && !lpFound) {
            startingSlab = { ...slabs[i] };
            if (currentLp <= slabs[i].slab && desiredLp <= slabs[i].slab) {
              contribution = numberOfPoints;
            } else {
              contribution += slabs[i].slab - currentLp;
              numberOfPoints = numberOfPoints - contribution;
            }
            lpFound = true;
          }
          if (lpFound) {
            if (slabs[i].slab !== startingSlab.slab) {
              if (desiredLp >= slabs[i].slab) {
                difference = 500;
                numberOfPoints = numberOfPoints - 500;
                contribution += 500;
                price += difference * slabs[i].price;
                timing += difference * slabs[i].timing;
              } else {
                difference = numberOfPoints;
                numberOfPoints = numberOfPoints - difference;
                price += difference * slabs[i].price;
                timing += difference * slabs[i].timing;
                contribution += difference;
              }
            } else {
              price += contribution * slabs[i].price;
              timing += contribution * slabs[i].timing;
            }
            if (desiredLp <= slabs[i].slab) {
              break;
            }
          }
        }
      }
    }
  }
  return {
    price,
    timing,
  };
}

function calculateTheFinalsRankedUnlock(pack, checkout) {
  let price = 0;
  let timing = 0;
  let numberOfGames = checkout.details.numberOfRounds;
  let gamePackPrice = checkout.fullPack.prices.find(
    (price) => price.slab >= numberOfGames
  );

  if (gamePackPrice) {
    price = gamePackPrice.price * numberOfGames;
    timing = gamePackPrice.timing * numberOfGames;
  }

  return {
    price,
    timing,
  };
}

function calculateTheFinalsBattlePass(pack, checkout) {
  const from = checkout.details?.currentBp;
  const to = checkout.details.desiredBp;
  const prices = checkout.fullPack.prices;
  const { price, timing } = calculateSlabPrice(prices, from, to);
  return {
    price,
    timing,
  };
}

function calculateLeagueOfLegendChampMastery(pack, checkout) {
  let price = 0;
  let timing = 0;
  let current = checkout?.details.currentMasterySlab || 1;
  let desired = checkout?.details.desiredMasterySlab || 4;

  pack?.prices?.forEach((slab) => {
    if (slab.slab >= current && slab.slab <= desired) {
      price = price + slab.price;
      timing = timing + slab.timing;
    }
  });

  price = price - pack?.prices[current - 1].price;
  timing = timing - pack?.prices[current - 1].timing;
  return {
    price,
    timing,
  };
}

function calculateMarvelHeroProficiency(pack, checkout) {
  let price = 0;
  let timing = 0;
  let current = checkout?.details.currentRankSlab || 1;
  let desired = checkout?.details.desiredRankSlab || 4;

  pack?.prices?.forEach((slab) => {
    if (slab.slab >= current && slab.slab <= desired) {
      price = price + slab.price;
      timing = timing + slab.timing;
    }
  });

  price = price - pack?.prices[current - 1].price;
  timing = timing - pack?.prices[current - 1].timing;
  return {
    price,
    timing,
  };
}

function calculateLeagueOfLegendClash(pack, checkout) {
  let price = 0;
  let timing = 0;
  let tier = checkout.tier;
  let boosters = parseInt(checkout?.details?.numberOfBoosters) || 1;
  let games = parseInt(checkout?.details?.numberOfGames) || 1;
  if (tier && boosters && games && pack?.prices) {
    const slab = pack.prices.find((packSlab) => packSlab.slab === tier?.value);
    price = slab?.price * games * boosters || 0;
    timing = slab?.timing * games || 0;
  }
  return {
    price,
    timing,
  };
}

function calculateLeagueOfLegendSoulFighter(pack, checkout) {
  let price = 0;
  let timing = 0;
  let rankTitle = checkout?.details?.soulFighterRankTitle || "Wood";
  let numberOfGames = checkout?.details?.numberOfGames || 1;

  if (pack.prices && rankTitle && numberOfGames) {
    const slab = pack.prices.find((packSlab) => packSlab.title === rankTitle);
    if (slab?.price && slab?.timing) {
      price = slab?.price * numberOfGames;
      timing = slab?.timing * numberOfGames;
    }
  }

  return {
    price,
    timing,
  };
}
function calculateHypeRoll(pack, checkout) {
  let from = checkout.details["currentMmr"];
  let to = checkout.details["desiredMmr"];
  let prices = pack.prices;
  let price = 0;
  let timing = 0;
  let totalDifference = to - from;
  if (totalDifference <= 0) {
    return {
      price,
      timing,
    };
  }
  let slabLowerBound = 0;
  let slabUpperBound = 0;
  let slabRate = 0;
  let slabTiming = 0;
  let difference = 0;
  let priceSlab = 0;
  let priceTiming = 0;

  for (let i = 0; i < prices.length; i++) {
    if (i == 0) {
      slabLowerBound = 0;
      slabUpperBound = prices[0]["slab"];
      slabRate = prices[0]["price"];
      slabTiming = prices[0]["timing"] ?? 0;
    } else {
      slabLowerBound = prices[i - 1]["slab"];
      slabUpperBound = prices[i]["slab"];
      slabRate = prices[i]["price"];
      slabTiming = prices[i]["timing"] || 0;
    }
    if (from > slabLowerBound && from <= slabUpperBound) {
      if (to <= slabUpperBound) {
        difference = to - from;
      } else {
        difference = slabUpperBound - from;
      }

      priceSlab = difference * slabRate;
      price += priceSlab;

      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (from <= slabLowerBound && to >= slabUpperBound) {
      difference = slabUpperBound - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (to > slabLowerBound && to <= slabUpperBound) {
      difference = to - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    }
  }
  return {
    price,
    timing,
  };
}

function faceitDivisionBoosting(pack, checkout) {
  const { currentDivisionTitle, desiredDivisionTitle } = checkout.details;
  if (!currentDivisionTitle || !desiredDivisionTitle) {
    return {
      price: 0,
      timing: 0,
    };
  }

  let currentRank = `${currentDivisionTitle}`;
  let desiredRank = `${desiredDivisionTitle}`;

  const slabs = pack.prices;
  let price = 0;
  let timing = 0;
  let fromFound = false;
  // console.log(currentRank, desiredRank);
  if (currentRank && desiredRank) {
    for (let i = 0; i < slabs.length; i++) {
      const from = slabs[i].title;
      const to = slabs[i + 1].title;
      if (from === currentRank) {
        price += slabs[i].price;
        timing += slabs[i].timing;
        fromFound = true;
        if (to === desiredRank) {
          break;
        }
      } else if (fromFound) {
        price += slabs[i].price;
        timing += slabs[i].timing;
      }
      if (to === desiredRank || from === desiredRank) {
        break;
      }
    }
  }
  return {
    price: price,
    timing: timing,
  };
}
function calculateAchievementsBoosting(pack, checkout) {
  let achievementsprice = 0;
  let achievementstiming = 0;
  const selectedBadges = pack.prices.filter((price) =>
    checkout.badges.includes(price.slab)
  );
  for (let i = 0; i < selectedBadges.length; i++) {
    achievementsprice = achievementsprice + selectedBadges[i].price;
    achievementstiming = achievementstiming + selectedBadges[i].timing;
  }
  return {
    price: achievementsprice,
    timing: achievementstiming,
  };
}
function calculateGadgesAndWeapons(pack, checkout) {
  let achievementsprice = 0;
  let achievementstiming = 0;
  const selectedBadges = pack.prices.filter((price) =>
    checkout.details?.gadgetsAndWeapons?.includes(price.slab)
  );
  for (let i = 0; i < selectedBadges.length; i++) {
    achievementsprice = achievementsprice + selectedBadges[i].price;
    achievementstiming = achievementstiming + selectedBadges[i].timing;
  }
  return {
    price: achievementsprice,
    timing: achievementstiming,
  };
}

function calculateUnratedWins(pack, checkout) {
  let price = 0;
  let timing = 0;

  let numberOfGames = checkout?.details?.numberOfGames || 1;
  let gamePackPrice = checkout.fullPack.prices[0];
  price = gamePackPrice.price * numberOfGames;
  timing = gamePackPrice.timing * numberOfGames;

  return {
    price: price,
    timing: timing,
  };
}
function calculateRoyaleLeague(pack, checkout) {
  let price = 0;
  let timing = 0;
  const league = checkout.details?.league;
  const prices = pack.prices?.find((price) => price.title === league);
  const basePrice = pack?.prices?.find(
    (price) => price.title === league && price.icon === "base_price"
  );
  if (league === "Casual League (Levels)") {
    const from = checkout.details?.currentLevel;
    const to = checkout.details?.desiredLevel;

    const difference = to - from;

    price += prices?.price * difference;
    timing += prices?.timing * difference;
    if (basePrice) {
      price += basePrice?.price;
    }
  } else if (
    league === "Competitive League (Ladders)" ||
    league === "Top 1k From Scratch (8% off)"
  ) {
    price += prices?.price;
    timing += prices?.timing;
  }
  return {
    price: price,
    timing: timing,
  };
}
function calculateRoyaleChallenges(pack, checkout) {
  let price = 0;
  let timing = 0;

  let numberOfGames = checkout?.details?.numberOfChallenges || 1;
  const mode = checkout.details?.mode || "Classic Challenges";
  let basePrice = checkout.fullPack.prices[0];
  price = basePrice.price * numberOfGames;
  timing = basePrice.timing * numberOfGames;
  if (mode === "Grand Challenges") {
    const grandPrice = pack.prices?.find(
      (op) => op.title === "Grand Challenges"
    );
    const pprice = price + (grandPrice?.price * price) / 100;
    price += pprice;
  }

  return {
    price: price,
    timing: timing,
  };
}

function calculateUnratedWinsFc(pack, checkout) {
  let price = 0;
  let timing = 0;

  let numberOfGames = checkout?.details?.numberOfWins || 1;
  let gamePackPrice = checkout.fullPack.prices[0];
  price = gamePackPrice.price * numberOfGames;
  timing = gamePackPrice.timing * numberOfGames;

  return {
    price: price,
    timing: timing,
  };
}

function calculateElearning(pack, checkout) {
  let price = 0;
  let timing = 0;
  if (!checkout?.details?.slab) {
    return {
      price: 0,
      timing: 0,
    };
  }

  const selectedSlab = pack.prices.find(
    (price) => price.slab === checkout?.details?.slab
  );
  if (!selectedSlab) {
    return {
      price,
      timing,
    };
  }
  let slabPrice = selectedSlab?.price;
  let slabTiming = selectedSlab?.timing;
  let games = 0;
  if (checkout?.details?.numberOfGames) {
    games = checkout?.details?.numberOfGames;
  }
  if (checkout?.details?.numberOfHours) {
    games = checkout?.details?.numberOfHours;
  }
  if (checkout?.details?.vodReviews) {
    games = checkout?.details?.vodReviews;
  }
  price = slabPrice * games;
  timing = slabTiming * games;

  return {
    price,
    timing,
  };
}
function reversePackOption(pack, checkout, originalPrice, game) {
  let selectedOptions = pack.pack_options.filter((option) =>
    checkout.packOptions.includes(option.id)
  );

  if (
    game.slug === "call-of-duty-boost" &&
    pack.slug !== "black-ops-6-weapon-leveling-boost"
  ) {
    selectedOptions = pack.pack_extra_options.filter((option) =>
      checkout.packOptions.includes(option.id)
    );
  }
  let removeFromBase = 0;
  let price = originalPrice;
}

function calculateDifficulty(pack, checkout, originalPrice, game) {
  let selectedOptions = pack.pack_options.filter(
    (option) => checkout.difficulty === option.id
  );
  if (
    game.slug === "call-of-duty-boost" &&
    pack.slug !== "black-ops-6-weapon-leveling-boost"
  ) {
    selectedOptions = pack.pack_extra_options.filter((option) =>
      checkout.packOptions.includes(option.id)
    );
  }
  let addToBase = 0;
  let price = originalPrice;
  for (let i = 0; i < selectedOptions.length; i++) {
    let calculatedPrice = 0;
    const option = selectedOptions[i];
    if (option?.type === "free") {
    }

    if (option.type === "variable") {
      calculatedPrice = (price * option.price) / 100;
    } else if (option.type === "fixed") {
      calculatedPrice = option.price;
    }
    if (option?.price_type === 0) {
      addToBase = addToBase + calculatedPrice;
    } else if (option?.price_type === 1) {
      addToBase = addToBase - calculatedPrice;
    }
  }
  return addToBase;
}
function calculatePackOption(pack, checkout, originalPrice, game, source) {
  let selectedOptions = [];
  if (source === "cart") {
    selectedOptions = pack.pack_options.filter(
      (option) =>
        checkout.packOptions.includes(option.id) && option.coupon_enable !== 0
    );
  } else if (source === "adjust_details") {
    selectedOptions = pack.pack_options.filter((option) =>
      checkout.packOptions.includes(option.id)
    );
  }
  if (source === "non_couponed") {
    selectedOptions = pack.pack_options.filter(
      (option) =>
        checkout.packOptions.includes(option.id) && option.coupon_enable === 0
    );
  }
  if (
    game.slug === "call-of-duty-boost" &&
    pack.slug !== "black-ops-6-weapon-leveling-boost"
  ) {
    selectedOptions = pack.pack_extra_options.filter((option) =>
      checkout.packOptions.includes(option.id)
    );
  }
  let addToBase = 0;
  let price = originalPrice;
  for (let i = 0; i < selectedOptions.length; i++) {
    let calculatedPrice = 0;
    const option = selectedOptions[i];
    if (option?.type === "free") {
    }

    if (option.type === "variable") {
      calculatedPrice = (price * option.price) / 100;
    } else if (option.type === "fixed") {
      calculatedPrice = option.price;
    }
    if (option?.price_type === 0) {
      addToBase = addToBase + calculatedPrice;
    } else if (option?.price_type === 1) {
      addToBase = addToBase - calculatedPrice;
    }
  }
  return addToBase;
}

function calculatePackExtraOptions(pack, checkout, originalPrice) {
  const selectedOptions = pack.pack_extra_options.filter((option) =>
    Object.keys(checkout.packExtraOptions).some((key) => {
      const value = checkout.packExtraOptions[key];

      if (Array.isArray(value)) {
        return value.includes(option.id);
      } else {
        return value == option.id;
      }
    })
  );

  let addToBase = 0;
  let price = originalPrice;

  for (const option of selectedOptions) {
    let calculatedPrice = 0;

    if (option.type === "variable") {
      calculatedPrice = (price * option.price) / 100;
    } else if (option.type === "fixed") {
      calculatedPrice = option.price;
    }

    if (option.price_type === 0) {
      addToBase += calculatedPrice;
    } else if (option.price_type === 1) {
      addToBase -= calculatedPrice;
    }
  }

  return addToBase;
}

function calculateQueue(pack, checkout, originalPrice) {
  const selectedQueue = pack?.pack_extra_options?.find(
    (option) => option.id == checkout.queue?.value
  );

  let addToBase = 0;
  let price = originalPrice;

  let calculatedPrice = 0;
  const option = selectedQueue;
  if (option?.type === "free") {
  }
  if (option?.type === "variable") {
    calculatedPrice = (price * option.price) / 100;
  } else if (option?.type === "fixed") {
    calculatedPrice = option.price;
  }
  if (option?.price_type === 0) {
    addToBase = addToBase + calculatedPrice;
  } else if (option?.price_type === 1) {
    addToBase = addToBase - calculatedPrice;
  }

  return addToBase;
}

function calculateCashback(user, price) {
  let cashback = 0;
  if (!user?.subscription) {
    cashback = (price * 1.5) / 100;
    return parseFloat(cashback).toFixed(2);
  }
  const { title } = user?.subscription;
  if (title === "Basic") {
    cashback = (price * 1.5) / 100;
  } else {
    cashback = (price * 3) / 100;
  }
  return parseFloat(cashback).toFixed(2);
}

function getDiscountCoupon(amount, coupon) {
  let discount = 0;
  if (coupon) {
    if (coupon.usage_type == 1) {
      discount = amount - (amount * coupon.discount) / 100;
    } else if (coupon.usage_type == 2) {
      discount = amount - coupon.discount;
    }
    return amount - discount;
  }
  return 0;
}

function calculateCurrency(price, defaultCurrency = null) {
  const { getUserCurrency } = useUserStore();
  const genericStore = useGenericStore();

  let userCurrency = getUserCurrency || 1;
  if (defaultCurrency) {
    userCurrency = defaultCurrency;
  }
  if (price && price > 0 && userCurrency) {
    let selectedCurrency = genericStore.getCurrencies.find(
      (currency) => currency.id === userCurrency
    );
    price = price * (selectedCurrency?.value || 1);
  }

  return price;
}

function calculateRoles(pack, checkout, originalPrice) {
  const roles = checkout.roles;
  const selectedRoles = checkout.fullGame?.roles?.filter((role) =>
    roles.includes(role.id)
  );
  let addToBase = 0;
  let optionedPrice = originalPrice;
  for (let i = 0; i < selectedRoles.length; i++) {
    let calculatedPrice = 0;
    const option = selectedRoles[i];
    if (option?.type === "free") {
    }

    if (option.type === "variable") {
      calculatedPrice = (optionedPrice * option.price) / 100;
    } else if (option.type === "fixed") {
      calculatedPrice = option.price;
    }
    if (option?.price_type === 0) {
      addToBase = addToBase + calculatedPrice;
    } else if (option?.price_type === 1) {
      addToBase = addToBase - calculatedPrice;
    }
  }
  return addToBase;
}

function calcuateProgressiveDiscount(price, pack) {
  let discount = 0;
  let progressiveDiscounts = pack.progress_discount || [];

  let array = progressiveDiscounts.filter((discount) => discount.slab <= price);

  let discounter = array[array.length - 1];
  if (discounter?.slab) {
    discount = price - (price * discounter.discount) / 100;
    return price - discount;
  }
  return discount;
}

// MMOS CALCULATOR
function calculateHonorFarm(pack, checkout) {
  let price = 0;
  let timing = 0;
  let desiredHonour = checkout?.details?.desiredHonour || 60000;
  desiredHonour = Math.round(desiredHonour / 5000);

  let gamePackPrice = checkout.fullPack.prices[0];
  price = gamePackPrice.price * desiredHonour;
  timing = gamePackPrice.timing * desiredHonour;

  return {
    price,
    timing,
  };
}
function calculateConquestFarm(pack, checkout) {
  let price = 0;
  let timing = 0;
  let desiredConquest = checkout?.details?.desiredConquest || 11000;
  desiredConquest = Math.round(desiredConquest / 550);
  let gamePackPrice = checkout.fullPack.prices[0];
  price = gamePackPrice.price * desiredConquest;
  timing = gamePackPrice.timing * desiredConquest;

  return {
    price,
    timing,
  };
}

function calculateLevelBoosting(pack, checkout) {
  const from = checkout?.details?.currentLevel || 1;
  const to = checkout?.details?.desiredLevel || 70;

  return calculateWoWLevelsDifference(pack.prices, from, to);
}
function calculateRatingBoosting(pack, checkout) {
  const from = checkout?.details?.currentRating || 1;
  const to = checkout?.details?.desiredRating || 70;
  const base_price = pack?.prices?.find((price) => price.icon === "base_price");
  let { price, timing } = calculateWoWLevelsDifference(pack.prices, from, to);
  if (base_price?.id) {
    price += base_price.price;
  }
  return {
    price,
    timing,
  };
}

function calculateWowRaidBoost(pack, checkout) {
  let price = 0;
  let timing = 0;

  const difficultyTitle = checkout?.details?.difficultyTitle;
  const lootType = checkout.details?.lootType;
  const numberOfBosses = checkout.details?.bosses;
  if (!difficultyTitle || !lootType || !numberOfBosses) {
    return {
      price,
      timing,
    };
  }
  const boss = BOSSESS[numberOfBosses];
  const slabPrice = pack?.prices?.find(
    (price) => price.title?.toLowerCase() === difficultyTitle?.toLowerCase()
  );

  if (!slabPrice) {
    return {
      price,
      timing,
    };
  }
  price += slabPrice.price;
  const lootTypePrice = slabPrice.slabs.lootType[lootType];
  const boosTypePrice = slabPrice.slabs.bosses[boss];

  if (lootTypePrice) {
    if (lootTypePrice.type === "variable") {
      price += (price * lootTypePrice.value) / 100;
    } else if (lootTypePrice.type === "fixed") {
      price += lootTypePrice.value;
    }
  }

  if (boosTypePrice) {
    if (boosTypePrice.type === "variable") {
      price += (price * boosTypePrice.value) / 100;
    } else if (boosTypePrice.type === "fixed") {
      price += boosTypePrice.value;
    }
  }
  return {
    price,
    timing,
  };
}

function calculateWoWGoldBoost(pack, checkout) {
  let price = 0;
  let timing = 0;
  const numberOfGold = checkout?.details?.numberOfGold;
  const pricePer100k = checkout?.details?.price;

  let pricePer1 = pricePer100k / 100000;
  price += numberOfGold * pricePer1;

  return {
    price,
    timing,
  };
}

function calculateWoWMythicPlus(pack, checkout) {
  let price = 0;
  let timing = 0;
  const keyStoneLvl = checkout.details?.desiredKeystone;
  const numberOfRuns = checkout.details?.numberOfMythic;

  const slab = pack.prices?.find((price) => price.slab === keyStoneLvl);
  if (slab) {
    price += numberOfRuns * slab.price;
    timing += numberOfRuns * slab.timing;
  }
  // const slab = pack.prices.
  return {
    price,
    timing,
  };
}

function calculateWoWLevelsDifference(prices, from, to) {
  let price = 0;
  let timing = 0;
  const totalDifference = to - from;
  if (totalDifference <= 0) {
    return {
      price,
      timing,
    };
  }

  let slabLowerBound = 0;
  let slabUpperBound = 0;
  let slabRate = 0;
  let slabTiming = 0;
  let difference = 0;
  let priceSlab = 0;
  let priceTiming = 0;
  for (let i = 0; i < prices.length; i++) {
    if (i == 0) {
      slabLowerBound = 0;
      slabUpperBound = prices[0]["slab"];
      slabRate = prices[0]["price"];
      slabTiming = prices[0]["timing"] ?? 0;
    } else {
      slabLowerBound = prices[i - 1]["slab"];
      slabUpperBound = prices[i]["slab"];
      slabRate = prices[i]["price"];
      slabTiming = prices[i]["timing"] || 0;
    }
    if (from > slabLowerBound && from <= slabUpperBound) {
      if (to <= slabUpperBound) {
        difference = to - from;
      } else {
        difference = slabUpperBound - from;
      }

      priceSlab = difference * slabRate;
      price += priceSlab;

      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (from <= slabLowerBound && to >= slabUpperBound) {
      difference = slabUpperBound - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    } else if (to > slabLowerBound && to <= slabUpperBound) {
      difference = to - slabLowerBound;
      priceSlab = difference * slabRate;
      price += priceSlab;
      priceTiming = difference * slabTiming;
      timing += priceTiming;
    }
  }
  return {
    price,
    timing,
  };
}

function calculateCamoBoost(pack, checkout) {
  let price = 0;
  let timing = 0;
  // console.log(checkout);

  if (checkout.getCamoSpecials?.id) {
    return {
      price: parseFloat(checkout.getCamoSpecials?.price),
      timing: checkout.getCamoSpecials?.timing,
    };
  }

  const camo = checkout.getCamoWeapon || [];
  camo.forEach((cam) => {
    price += cam.price + (cam.catPrice * cam.price) / 100;
    timing += cam.timing;
  });

  return {
    price: price,
    timing: timing,
  };
}

function calculatePrestigeBoost(pack, checkout) {
  let price = 0;
  let timing = 0;

  let currentPrestige = checkout.getDetails?.currentPrestige;
  let desiredPrestige = checkout.getDetails?.desiredPrestige;
  let currentPrestigeLevel = checkout.getDetails?.currentPrestigeLevel;
  let desiredPrestigeLevel = checkout.getDetails?.desiredPrestigeLevel;

  const prices = pack.prices;

  for (let i = 0; i < prices.length; i++) {
    const slab = prices[i];
    const slabPrices = JSON.parse(prices[i].slabs);
    // console.log("timing", slab.timing);
    if (slab.id >= currentPrestige && slab.id <= desiredPrestige) {
      if (slab.id === desiredPrestige && slab.id === currentPrestige) {
        const startingPoint = currentPrestigeLevel;
        const endingPoint = desiredPrestigeLevel;
        for (let j = startingPoint; j <= endingPoint; j++) {
          const levelPrice = parseFloat(slabPrices[j]);
          timing += slab.timing * levelPrice;
          price += levelPrice;
        }
      } else if (slab.id === currentPrestige && slab.id !== desiredPrestige) {
        const startingPoint = currentPrestigeLevel;
        const endingPoint = 55;

        for (let j = startingPoint; j <= endingPoint; j++) {
          const levelPrice = parseFloat(slabPrices[j]);
          price += levelPrice;
          timing += slab.timing * levelPrice;
        }
      } else if (slab.id > currentPrestige && slab.id < desiredPrestige) {
        for (let j = 1; j <= 55; j++) {
          const levelPrice = parseFloat(slabPrices[j]);
          price += levelPrice;
          timing += slab.timing * levelPrice;
        }
      } else if (slab.id === desiredPrestige && slab.id !== currentPrestige) {
        const startingPoint = 1;
        const endingPoint = desiredPrestigeLevel;
        for (let j = startingPoint; j <= endingPoint; j++) {
          const levelPrice = parseFloat(slabPrices[j]);
          price += levelPrice;
          timing += slab.timing * levelPrice;
        }
      }
    }
  }
  return {
    price: price,
    timing: timing,
  };
}
function calculateAboveAllBoost(pack, checkout) {
  let price = 0;
  let timing = 0;

  const {
    currentRankTitle,
    currentDivisionTitle,
    desiredRankTitle,
    desiredDivisionTitle,
  } = checkout.details;
  if (!currentRankTitle || !desiredRankTitle) {
    return {
      price: 0,
      timing: 0,
    };
  }

  let currentRank = `${currentRankTitle} ${currentDivisionTitle}`;
  let desiredRank = `${desiredRankTitle} ${desiredDivisionTitle}`;
  if (!currentDivisionTitle) {
    currentRank = currentRankTitle;
  }
  if (!desiredDivisionTitle) {
    desiredRank = desiredRankTitle;
  }

  const slabs = pack.prices;
  const slab = slabs.find((slb) => {
    console.log(slb.title);
    return slb.title === `${currentRank} > ${desiredRank}`;
  });
  if (slab) {
    price = slab.price;
    timing = slab.timing;
  }

  return {
    price,
    timing,
  };
}
function calculateWeaponLevelBoost(pack, checkout) {
  let price = 0;
  let timing = 0;

  const weapon = checkout.getCamoWeapon || [];
  if (!weapon) {
    return {
      price,
      timing,
    };
  }
  const weaponPrice = weapon[0];

  const from = checkout?.details?.currentLevel || 1;
  const to = checkout?.details?.desiredLevel || 1000;

  const prices = calculateWoWLevelsDifference(pack.prices, from, to);
  price = prices.price;
  timing = prices.timing;
  if (weaponPrice?.type === "variable") {
    price += (price * weaponPrice.price) / 100;
  } else if (weaponPrice?.type === "fixed") {
    price += weaponPrice.price;
  }
  return {
    price,
    timing,
  };
}

function calculateNukeBoost(pack, checkout) {
  let price = 0;
  let timing = 0;
  const optionsSelected = checkout.getDetails?.items || [];
  const packPrices = pack?.prices || [];

  const ii = packPrices?.filter((pp) => optionsSelected.includes(pp.id)) || [];

  ii.forEach((i) => {
    if (i.type === 0) {
      price += i.price;
    } else if (i.type === 1) {
      price -= i.price;
    }
    timing += i.timing;
  });
  return {
    price,
    timing,
  };
}

function calculatePlatform(getSelectedPlatform, platforms, basePrice) {
  let addToBase = 0;
  if (getSelectedPlatform && platforms?.length > 0) {
    const selectedPlatform = platforms.find(
      (plat) => plat?.title.id === getSelectedPlatform
    );
    if (
      selectedPlatform?.type === "variable" &&
      selectedPlatform?.price_type === 0
    ) {
      addToBase = (basePrice * selectedPlatform.price) / 100;
    }
  }
  return addToBase;
}
function calculateServer(servers, passedServer, basePrice, game, pack) {
  let addToBase = 0;
  if (
    servers &&
    servers.length > 0 &&
    passedServer &&
    game?.slug !== "world-of-warcraft-boost"
  ) {
    let selectedServer = servers.find((server) => server.id == passedServer);
    if (
      selectedServer?.type === "variable" &&
      selectedServer?.price_type === 0
    ) {
      addToBase = (basePrice * selectedServer.price) / 100;
    }
  }

  if (
    game?.slug === "world-of-warcraft-boost" &&
    servers?.length > 0 &&
    pack?.slug !== "buy-wow-gold"
  ) {
    let selectedServer = servers.find((server) => server.id == passedServer);
    if (
      selectedServer?.type === "variable" &&
      selectedServer?.price_type === 0
    ) {
      addToBase = (basePrice * selectedServer.price) / 100;
    }
  }

  return addToBase;
}

function calculateMarvelRivalsRankBoost(pack, checkout) {
  let price = 0;
  let timing = 0;
  if (
    !checkout?.details.currentRankTitle ||
    !checkout?.details.desiredRankTitle
  ) {
    return {
      price: 0,
      timing: 0,
    };
  }
  let currentRank = `${checkout?.details?.currentRankTitle} ${checkout?.details?.currentDivisionTitle}`;
  if (!checkout.details?.currentDivisionTitle) {
    currentRank = checkout?.details?.currentRankTitle;
  }
  let desiredRank = "";
  if (checkout?.details?.desiredDivisionTitle) {
    desiredRank = `${checkout?.details?.desiredRankTitle} ${checkout?.details?.desiredDivisionTitle}`;
  } else {
    desiredRank = `${checkout?.details?.desiredRankTitle}`;
  }

  const slabs = pack.prices?.filter(
    (price) => price.title !== "Ultimate Champion medals"
  );
  let fromFound = false;
  let lpFound = false;
  let startingSlab = null;
  let contribution = 0;
  let difference = 0;

  if (currentRank && desiredRank) {
    const desiredLp = checkout.details.desiredRankPoints;
    const currentLp = checkout.details.currentRankPoints;
    let numberOfPoints = desiredLp - currentLp;
    let onlyLpPoints = parseInt(desiredLp);
    let lpPrice = 0;

    for (let i = 0; i < slabs.length; i++) {
      if (slabs[i].title) {
        const from = slabs[i].title.split(" > ")[0];
        const to = slabs[i].title.split(" > ")[1];
        if (from === currentRank) {
          price += slabs[i].price;
          timing += slabs[i].timing;
          fromFound = true;
          if (to === desiredRank && !["Eternity"].includes(desiredRank)) {
            break;
          }
        } else if (fromFound) {
          price += slabs[i].price;
          timing += slabs[i].timing;
        }
        if (
          (to === desiredRank || from === desiredRank) &&
          !["Eternity"].includes(desiredRank)
        ) {
          break;
        }
      } else {
        if (desiredLp === 0) {
          break;
        }
        if (!["Eternity"].includes(checkout.details.currentRankTitle)) {
          if (slabs[i].slab !== 0) {
            if (onlyLpPoints < 100) {
              lpPrice += onlyLpPoints * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            } else {
              lpPrice += 100 * slabs[i].price;
              timing += desiredLp * slabs[i].timing;
            }
            if (onlyLpPoints > 100) {
              onlyLpPoints = onlyLpPoints - 100;
            }
          }
          if (desiredLp <= slabs[i].slab) {
            price += lpPrice;
            break;
          }
        } else {
          if (currentLp <= slabs[i].slab && !lpFound) {
            startingSlab = { ...slabs[i] };
            if (currentLp <= slabs[i].slab && desiredLp <= slabs[i].slab) {
              contribution = numberOfPoints;
            } else {
              contribution += slabs[i].slab - currentLp;
              numberOfPoints = numberOfPoints - contribution;
            }
            lpFound = true;
          }
          if (lpFound) {
            if (slabs[i].slab !== startingSlab.slab) {
              if (desiredLp >= slabs[i].slab) {
                difference = 100;
                numberOfPoints = numberOfPoints - 100;
                contribution += 100;
                price += difference * slabs[i].price;
                timing += difference * slabs[i].timing;
              } else {
                difference = numberOfPoints;
                numberOfPoints = numberOfPoints - difference;
                price += difference * slabs[i].price;
                timing += difference * slabs[i].timing;
                contribution += difference;
              }
            } else {
              price += contribution * slabs[i].price;
              timing += contribution * slabs[i].timing;
            }

            if (desiredLp <= slabs[i].slab) {
              break;
            }
          }
        }
      }
    }
  }
  return {
    price,
    timing,
  };
}

const calculatePoeCurrencyBoost = (pack, checkoud) => {
  let timing = 0;
  let price = 0;
  const selectedCurrency = pack.prices?.find(
    (price) => price.id === checkoud.details.orbId
  );
  if (selectedCurrency) {
    price = selectedCurrency.price * checkoud.details.numberOfOrbs;
    timing = selectedCurrency.timing * 60;
  }
  return {
    price,
    timing,
  };
};
const calculatePoeGearBoost = (pack, checkout) => {
  let timing = 0;
  let price = 0;

  const selectedGear = pack.prices?.find(
    (price) => price.id === checkout.details.gearId
  );
  if (selectedGear) {
    price = selectedGear.price;
    timing = selectedGear.timing * 60;
  }
  return {
    price,
    timing,
  };
};

const calculateAscensionTrials = (pack, checkout) => {
  let timing = 0;
  let price = 0;

  const selectedTrials =
    checkout.details?.trials?.map((trial) => trial.id) || [];

  if (selectedTrials) {
    const trials = pack.prices?.filter((price) =>
      selectedTrials.includes(price.id)
    );

    trials.forEach((trial) => {
      price += trial.price;
      timing += trial.timing;
    });
  }
  return {
    price,
    timing,
  };
};

const calculateCampaignBoost = (pack, checkout) => {
  let timing = 0;
  let price = 0;

  const selectedTrials = checkout.details?.acts?.map((trial) => trial.id) || [];

  if (selectedTrials) {
    const trials = pack.prices?.filter((price) =>
      selectedTrials.includes(price.id)
    );

    trials.forEach((trial) => {
      price += trial.price;
      timing += trial.timing;
    });
  }
  return {
    price,
    timing,
  };
};
function calculateChampionRankBoosting(pack, checkout) {
  let from = checkout?.details?.currentRankPoints || 0;
  let to = checkout?.details?.desiredRankPoints || 100;
  if (pack.id === 123) {
    return calculatePredatorSlabPrice(pack.prices, from, to);
  }
  return calculateSlabPrice(pack.prices, from, to);
}

function calculateFc25Coins(pack, checkout) {
  let timing = 0;
  let price = 0;
  let numberOfCoins = checkout.getDetails.coins || 0;

  const baseSlab = 100000;
  const basePrice = pack.prices?.find(
    (price) => price.title === "starting_price"
  );
  const stepSize = 10000;
  const priceIncrement = pack.prices?.find(
    (price) => price.title === "step_price"
  )?.price;

  const baseTiming = basePrice?.timing;

  if (numberOfCoins >= baseSlab && numberOfCoins % stepSize === 0) {
    const steps = (numberOfCoins - baseSlab) / stepSize;
    price = basePrice?.price + steps * priceIncrement;
    timing = baseTiming + steps * baseTiming;
  }

  return {
    price: price, // round to 2 decimals
    timing,
  };
}
function calculateFc25Coaching(pack, checkout) {
  let timing = 0;
  let price = 0;
  let numberOfHours = checkout.getDetails.numberOfHours || 0;

  const coinSlab = pack.prices?.find((price) => price.slab === numberOfHours);
  if (coinSlab) {
    price += coinSlab.price;
    timing += coinSlab.timing;
  }

  return {
    price,
    timing,
  };
}
function calculateFc25PlayoffBoost(pack, checkout) {
  let timing = 0;
  let price = 0;
  let numberOfWins = checkout.getDetails.numberOfWins || 0;
  const coinSlab = pack.prices?.find((price) => price.slab <= numberOfWins);
  if (coinSlab) {
    price += coinSlab.price * numberOfWins;
    timing += coinSlab.timing;
  }

  return {
    price,
    timing,
  };
}

function calculateFc25BattleBoost(pack, checkout) {
  let timing = 0;
  let price = 0;
  let numberOfWins = checkout.getDetails.numberOfWins || 0;
  let difficultyTitle = checkout.getDetails.difficultyTitle || 0;

  const coinSlab = pack.prices?.find(
    (price) => price.title === difficultyTitle
  );
  if (coinSlab) {
    price += coinSlab.price * numberOfWins;
    timing += coinSlab.timing;
  }

  return {
    price,
    timing,
  };
}

function calculateFc25ObjectiveBoost(pack, checkout) {
  let timing = 0;
  let price = 0;

  let numberOfObjectives = checkout.getDetails.numberOfObjectives || 0;
  let objectiveTitle = checkout.getDetails.objectiveTitle || 0;

  const slab = pack?.prices?.find((price) => price.title === objectiveTitle);
  console.log("numberOfObjectives", numberOfObjectives);
  if (slab && objectiveTitle !== "Rush Objectives") {
    price += slab.price * numberOfObjectives;
    timing += slab.timing * numberOfObjectives;
  } else if (objectiveTitle === "Rush Objectives") {
    price += slab.price;
    timing += slab.timing;
  }

  return {
    price,
    timing,
  };
}
function calculateFc25ChampionsFinal(pack, checkout) {
  let timing = 0;
  let price = 0;
  let platformSlab = null;
  let desiredRankTitle = checkout.getDetails?.desiredRank?.title || "";

  const slab = pack.prices?.find((price) => price.title === desiredRankTitle);
  if (slab) {
    price += slab.price;
    timing += slab.timing;
  }
  if (slab?.platform_slabs) {
    platformSlab = slab.platform_slabs;
  }
  return {
    price,
    timing,
    platformSlab,
  };
}
function calculateFc25DivisionRivalsWins(pack, checkout) {
  let timing = 0;
  let price = 0;

  let numberOfWins = checkout.details?.numberOfWins || 0;
  const optionSlabs = checkout.details?.optionSlabs || [];

  const slab = pack.prices?.find((slab) => optionSlabs?.includes(slab.slab));
  if (slab) {
    price += slab.price * numberOfWins;
    timing += slab.timing;
  }
  return {
    price,
    timing,
  };
}

function calculateFc25DivisionRivals(pack, checkout) {
  let timing = 0;
  let price = 0;

  const boostType = checkout.details?.boostType;
  if (boostType === "Division Boost") {
    const optionSlabs = checkout.details?.optionSlabs || [];

    const slabs = pack.prices?.filter((slab) =>
      optionSlabs?.includes(slab.slab)
    );

    slabs.forEach((slab) => {
      price += slab.price;
      timing += slab.timing;
    });
  }

  if (boostType === "Qualification Points") {
    const numberOfRivalPoints = checkout.details?.numberOfRivalPoints || 0;
    const slab = pack.prices?.find(
      (price) => price.title === "CQP" && price.slab === numberOfRivalPoints
    );

    if (slab) {
      price += slab.price;
      timing += slab.timing;
    }
  }

  return {
    price,
    timing,
  };
}

function calculateGalacticWinBoost(pack, checkout) {
  let timing = 0;
  let price = 0;

  const maxPoints = 2999;
  const numberOfGalacticGuns = checkout.details.numberOfGalacticGuns || 0;
  const numberOfPoints = checkout.details.numberOfPoints || 0;
  const rank = checkout.details.currentRank?.title || "";
  const slab = pack.prices?.find((price) => price.title === rank);

  if (slab) {
    const slabPrice = slab.price;
    const discountPercent = numberOfPoints > 0 ? numberOfPoints / maxPoints : 0;

    for (let i = 0; i < numberOfGalacticGuns; i++) {
      let finalPrice = slabPrice;

      if (i === 0 && discountPercent > 0) {
        const discount = slabPrice * discountPercent;
        finalPrice = slabPrice - discount;
      }

      price += finalPrice;
      timing += slab.timing;
    }
  }

  return {
    price,
    timing,
  };
}

function calculateOWDriveBoost(pack, checkout) {
  let timing = 0;
  let price = 0;

  const currentRank = checkout.details.currentRankTitle;
  const basePrice = pack.prices?.find(
    (price) => price.title === `${currentRank} starting_price`
  );
  const priceIncrement = pack.prices?.find(
    (price) => price.title === `${currentRank} every_step_price`
  );
  const stepSize = 50;

  const currentDrive = checkout.details?.currentDrive;
  const desiredDrive = checkout.details?.desiredDrive;

  price += basePrice?.price;
  timing += basePrice?.timing;
  const steps = Math.abs(desiredDrive - currentDrive) / stepSize;

  for (let i = 0; i < steps; i++) {
    price += priceIncrement?.price;
    timing += priceIncrement?.timing;
  }
  return {
    price: price, // round to 2 decimals
    timing,
  };
}

function calculateOw2StadiumBoost(pack, checkout) {
  let timing = 0;
  let price = 0;
  let current = checkout?.details.currentRankSlab || 1;
  let desired = checkout?.details.desiredRankSlab || 2;

  pack?.prices?.forEach((slab) => {
    if (slab.slab >= current && slab.slab <= desired) {
      price = price + slab.price;
      timing = timing + slab.timing;
    }
  });

  price = price - pack?.prices[current - 1].price;
  timing = timing - pack?.prices[current - 1].timing;
  return {
    price: price, // round to 2 decimals
    timing,
  };
}

function calculateRoyalePathOfLegends(pack, checkout) {
  let timing = 0;
  let price = 0;
  if (checkout.details?.currentRank) {
    const infos = calculateMarvelRivalsRankBoost(pack, checkout);
    if (infos.price && infos.timing) {
      price = infos.price;
      timing = infos.timing;
    }
  } else if (checkout.details?.currentMedals >= 0) {
    const from = checkout?.details?.currentMedals || 0;
    const to = checkout?.details?.desiredMedals || 70;
    const prices = pack.prices?.find(
      (price) => price.title === "Ultimate Champion medals"
    );
    const basePrice = prices?.price;
    if (basePrice) {
      price += basePrice;
      timing += prices?.timing || 0;
    }
    const slabs = JSON.parse(prices?.slabs);
    let current = from;

    while (current < to) {
      let step = 50;

      const end = Math.min(current + step, to);
      const slab = Object.entries(slabs)
        .reverse()
        .find(([key, value]) => {
          const pslab = parseInt(key);
          return pslab <= current;
        });
      if (slab) {
        const slabPrice = parseFloat(slab[1]);
        console.log("end", end);
        console.log("slabPrice", slabPrice);
        price += slabPrice;
      }

      current = end;
    }
  }

  return {
    price,
    timing,
  };
}

function calculateRoyaleArenaTrophies(pack, checkout) {
  const from = checkout?.details?.currentTrophies || 0;
  const to = checkout?.details?.desiredTrophies || 9000;

  let price = 0;
  let timing = 0;

  // Get base price (if exists)
  const basePrice = pack.prices.find((p) => p.title === "base_price");
  if (basePrice) {
    price += basePrice.price;
    timing += basePrice.timing || 0;
  }

  const slabs = pack.prices?.filter((p) => p.title !== "base_price");
  // console.log(slabs);

  let current = from;

  while (current < to) {
    let step = 0;

    if (current < 1000) {
      step = 1000 - current;
    } else if (current < 5000) {
      step = 250;
    } else {
      step = 100;
    }

    const end = Math.min(current + step, to);
    const slab = [...slabs].reverse().find((p) => {
      return p.slab <= current;
    });

    if (slab) {
      price += slab.price;
      timing += slab.timing || 0;
    } else {
      console.warn(`No slab found for ${current}–${end}`);
    }

    current = end;
  }
  return {
    price,
    timing,
  };
}
function calculateRoyaleTrophies(pack, checkout) {
  const from = checkout?.details?.currentTrophies || 1;
  const to = checkout?.details?.desiredTrophies || 9000;

  return calculateWoWLevelsDifference(pack.prices, from, to);
}
function calculateClrBoost(pack, checkout) {
  let price = 0;
  let timing = 0;

  const packPrice = pack.prices?.find((price) => price.title === "CLR20");
  if (packPrice) {
    price += packPrice?.price;
    timing += packPrice?.timing;
  }
  return {
    price,
    timing,
  };
}
function handlePriceIncrementToBase(pack, checkout, basePrice) {
  let price = basePrice;
  if (!checkout.getSelectedPlatform) return price;
  if (!pack?.platform_increment) return price;
  if (pack?.platform_increment?.length > 0) {
    const selectedPlatform = pack?.platform_increment?.find(
      (platform) => platform.platform_id === checkout.getSelectedPlatform
    );
    if (!selectedPlatform) return basePrice;

    const incrementValue =
      selectedPlatform.price_type === "fixed"
        ? selectedPlatform.price
        : (basePrice * selectedPlatform.price) / 100;

    if (selectedPlatform.price_direction === "positive") {
      price += incrementValue;
    } else if (selectedPlatform.price_direction === "negative") {
      price -= incrementValue;
    }
  }
  return price;
}
function handlePlatInc(pack, selectedPlatform, basePrice) {
  let price = basePrice;
  if (!selectedPlatform) return 0;
  if (!pack?.platform_increment) return 0;

  if (pack?.platform_increment?.length > 0) {
    const selPlat = pack?.platform_increment?.find(
      (platform) => platform.platform_id === selectedPlatform
    );
    if (!selPlat) return 0;

    const incrementValue =
      selPlat.price_type === "fixed"
        ? selPlat.price
        : (basePrice * selPlat.price) / 100;

    if (selPlat.price_direction === "positive") {
      price += incrementValue;
    } else if (selPlat.price_direction === "negative") {
      price -= incrementValue;
    }
  }
  return price;
}
function handlePlatformSlab(pack, detail, platform, basePrice) {
  try {
    let price = 0;

    if (pack.id === 111) {
      let platformSlab = null;
      let desiredRankTitle = detail?.desiredRank?.title || "";
      const slab = pack.prices?.find(
        (price) => price.title === desiredRankTitle
      );
      console.log();
      if (slab?.platform_slabs) {
        platformSlab = slab.platform_slabs;
        platformSlab = platformSlab[plats[platform]];
      }
      price =
        platformSlab.type === "fixed"
          ? platformSlab.price
          : (basePrice * platformSlab.price) / 100;
    }

    return price;
  } catch (error) {
    return 0;
  }
}

export {
  calculateChoose,
  calculateCurrency,
  calculatePackOption,
  calculateRoles,
  calculatePlatform,
  calculateServer,
  calculatePackExtraOptions,
  handlePlatInc,
  handlePlatformSlab,
};
